import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/food/food-1.webp'


const _withScopeId = n => (_pushScopeId("data-v-2d771eca"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "bg_primary filter-wrap style-one ptb-100" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "container" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "row" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "col-lg-3" }, [
      /*#__PURE__*/_createElementVNode("ul", {
        class: "nav nav-tabs menu-tablist style-one",
        role: "tablist"
      }, [
        /*#__PURE__*/_createElementVNode("li", { class: "nav-item" }, [
          /*#__PURE__*/_createElementVNode("button", {
            class: "nav-link active",
            "data-bs-toggle": "tab",
            "data-bs-target": "#tacos",
            type: "button",
            role: "tab"
          }, " Tacos ")
        ]),
        /*#__PURE__*/_createElementVNode("li", { class: "nav-item" }, [
          /*#__PURE__*/_createElementVNode("button", {
            class: "nav-link",
            "data-bs-toggle": "tab",
            "data-bs-target": "#bowls",
            type: "button",
            role: "tab"
          }, " Bowls ")
        ]),
        /*#__PURE__*/_createElementVNode("li", { class: "nav-item" }, [
          /*#__PURE__*/_createElementVNode("button", {
            class: "nav-link",
            "data-bs-toggle": "tab",
            "data-bs-target": "#quesadillas",
            type: "button",
            role: "tab"
          }, " Quesadillas ")
        ]),
        /*#__PURE__*/_createElementVNode("li", { class: "nav-item" }, [
          /*#__PURE__*/_createElementVNode("button", {
            class: "nav-link",
            "data-bs-toggle": "tab",
            "data-bs-target": "#sides",
            type: "button",
            role: "tab"
          }, " Sides ")
        ]),
        /*#__PURE__*/_createElementVNode("li", { class: "nav-item" }, [
          /*#__PURE__*/_createElementVNode("button", {
            class: "nav-link",
            "data-bs-toggle": "tab",
            "data-bs-target": "#desserts",
            type: "button",
            role: "tab"
          }, " Desserts ")
        ]),
        /*#__PURE__*/_createElementVNode("li", { class: "nav-item" }, [
          /*#__PURE__*/_createElementVNode("button", {
            class: "nav-link",
            "data-bs-toggle": "tab",
            "data-bs-target": "#drinks",
            type: "button",
            role: "tab"
          }, " Drinks ")
        ])
      ])
    ]),
    /*#__PURE__*/_createElementVNode("div", { class: "col-lg-9" }, [
      /*#__PURE__*/_createElementVNode("div", { class: "tab-content" }, [
        /*#__PURE__*/_createElementVNode("div", {
          class: "tab-pane fade show active",
          id: "tacos",
          role: "tabpanel"
        }, [
          /*#__PURE__*/_createElementVNode("div", { class: "food-list-wrap style-one" }, [
            /*#__PURE__*/_createElementVNode("div", { class: "food-card style-five" }, [
              /*#__PURE__*/_createElementVNode("div", { class: "food-img" }, [
                /*#__PURE__*/_createElementVNode("img", {
                  src: "https://images.pexels.com/photos/24182334/pexels-photo-24182334.jpeg?auto=compress&cs=tinysrgb&w=500&h=500&fit=crop",
                  alt: "Birria Tacos"
                })
              ]),
              /*#__PURE__*/_createElementVNode("div", { class: "food-info-wrap" }, [
                /*#__PURE__*/_createElementVNode("div", { class: "food-title" }, [
                  /*#__PURE__*/_createElementVNode("h3", null, [
                    /*#__PURE__*/_createTextVNode(" Birria Tacos "),
                    /*#__PURE__*/_createElementVNode("span", null, "(450 cal)")
                  ]),
                  /*#__PURE__*/_createElementVNode("p", null, " Slow-cooked halal beef birria with melted cheese, onions, cilantro, and consommé for dipping ")
                ]),
                /*#__PURE__*/_createElementVNode("div", { class: "food-price" }, [
                  /*#__PURE__*/_createElementVNode("h4", null, "$12.99")
                ])
              ])
            ]),
            /*#__PURE__*/_createElementVNode("div", { class: "food-card style-five" }, [
              /*#__PURE__*/_createElementVNode("div", { class: "food-img" }, [
                /*#__PURE__*/_createElementVNode("img", {
                  src: "https://images.pexels.com/photos/1059905/pexels-photo-1059905.jpeg?auto=compress&cs=tinysrgb&w=500&h=500&fit=crop",
                  alt: "Carnitas Tacos"
                })
              ]),
              /*#__PURE__*/_createElementVNode("div", { class: "food-info-wrap" }, [
                /*#__PURE__*/_createElementVNode("div", { class: "food-title" }, [
                  /*#__PURE__*/_createElementVNode("h3", null, [
                    /*#__PURE__*/_createTextVNode(" Carnitas Tacos "),
                    /*#__PURE__*/_createElementVNode("span", null, "(380 cal)")
                  ]),
                  /*#__PURE__*/_createElementVNode("p", null, " Tender halal pork carnitas with pineapple salsa, onions, and cilantro on corn tortillas ")
                ]),
                /*#__PURE__*/_createElementVNode("div", { class: "food-price" }, [
                  /*#__PURE__*/_createElementVNode("h4", null, "$11.99")
                ])
              ])
            ]),
            /*#__PURE__*/_createElementVNode("div", { class: "food-card style-five" }, [
              /*#__PURE__*/_createElementVNode("div", { class: "food-img" }, [
                /*#__PURE__*/_createElementVNode("img", {
                  src: "https://images.pexels.com/photos/1640774/pexels-photo-1640774.jpeg?auto=compress&cs=tinysrgb&w=500&h=500&fit=crop",
                  alt: "Chicken Tinga Tacos"
                })
              ]),
              /*#__PURE__*/_createElementVNode("div", { class: "food-info-wrap" }, [
                /*#__PURE__*/_createElementVNode("div", { class: "food-title" }, [
                  /*#__PURE__*/_createElementVNode("h3", null, [
                    /*#__PURE__*/_createTextVNode(" Chicken Tinga Tacos "),
                    /*#__PURE__*/_createElementVNode("span", null, "(320 cal)")
                  ]),
                  /*#__PURE__*/_createElementVNode("p", null, " Shredded halal chicken in smoky chipotle sauce with avocado crema and cotija cheese ")
                ]),
                /*#__PURE__*/_createElementVNode("div", { class: "food-price" }, [
                  /*#__PURE__*/_createElementVNode("h4", null, "$10.99")
                ])
              ])
            ])
          ])
        ]),
        /*#__PURE__*/_createElementVNode("div", {
          class: "tab-pane fade",
          id: "bowls",
          role: "tabpanel"
        }, [
          /*#__PURE__*/_createElementVNode("div", { class: "food-list-wrap style-one" }, [
            /*#__PURE__*/_createElementVNode("div", { class: "food-card style-five" }, [
              /*#__PURE__*/_createElementVNode("div", { class: "food-img" }, [
                /*#__PURE__*/_createElementVNode("img", {
                  src: "https://images.pexels.com/photos/1583884/pexels-photo-1583884.jpeg?auto=compress&cs=tinysrgb&w=500&h=500&fit=crop",
                  alt: "Burrito Bowl"
                })
              ]),
              /*#__PURE__*/_createElementVNode("div", { class: "food-info-wrap" }, [
                /*#__PURE__*/_createElementVNode("div", { class: "food-title" }, [
                  /*#__PURE__*/_createElementVNode("h3", null, [
                    /*#__PURE__*/_createTextVNode(" Burrito Bowl "),
                    /*#__PURE__*/_createElementVNode("span", null, "(520 cal)")
                  ]),
                  /*#__PURE__*/_createElementVNode("p", null, " Your choice of protein with rice, beans, lettuce, pico de gallo, cheese, and sour cream ")
                ]),
                /*#__PURE__*/_createElementVNode("div", { class: "food-price" }, [
                  /*#__PURE__*/_createElementVNode("h4", null, "$13.99")
                ])
              ])
            ]),
            /*#__PURE__*/_createElementVNode("div", { class: "food-card style-five" }, [
              /*#__PURE__*/_createElementVNode("div", { class: "food-img" }, [
                /*#__PURE__*/_createElementVNode("img", {
                  src: "https://images.pexels.com/photos/769969/pexels-photo-769969.jpeg?auto=compress&cs=tinysrgb&w=500&h=500&fit=crop",
                  alt: "Power Bowl"
                })
              ]),
              /*#__PURE__*/_createElementVNode("div", { class: "food-info-wrap" }, [
                /*#__PURE__*/_createElementVNode("div", { class: "food-title" }, [
                  /*#__PURE__*/_createElementVNode("h3", null, [
                    /*#__PURE__*/_createTextVNode(" Power Bowl "),
                    /*#__PURE__*/_createElementVNode("span", null, "(480 cal)")
                  ]),
                  /*#__PURE__*/_createElementVNode("p", null, " Grilled halal chicken, quinoa, black beans, corn, bell peppers, and lime vinaigrette ")
                ]),
                /*#__PURE__*/_createElementVNode("div", { class: "food-price" }, [
                  /*#__PURE__*/_createElementVNode("h4", null, "$12.99")
                ])
              ])
            ])
          ])
        ]),
        /*#__PURE__*/_createElementVNode("div", {
          class: "tab-pane fade",
          id: "quesadillas",
          role: "tabpanel"
        }, [
          /*#__PURE__*/_createElementVNode("div", { class: "food-list-wrap style-one" }, [
            /*#__PURE__*/_createElementVNode("div", { class: "food-card style-five" }, [
              /*#__PURE__*/_createElementVNode("div", { class: "food-img" }, [
                /*#__PURE__*/_createElementVNode("img", {
                  src: "https://images.pexels.com/photos/1059904/pexels-photo-1059904.jpeg?auto=compress&cs=tinysrgb&w=500&h=500&fit=crop",
                  alt: "Cheese Quesadilla"
                })
              ]),
              /*#__PURE__*/_createElementVNode("div", { class: "food-info-wrap" }, [
                /*#__PURE__*/_createElementVNode("div", { class: "food-title" }, [
                  /*#__PURE__*/_createElementVNode("h3", null, [
                    /*#__PURE__*/_createTextVNode(" Cheese Quesadilla "),
                    /*#__PURE__*/_createElementVNode("span", null, "(420 cal)")
                  ]),
                  /*#__PURE__*/_createElementVNode("p", null, " Flour tortilla filled with melted Monterey Jack and cheddar cheese, served with guacamole ")
                ]),
                /*#__PURE__*/_createElementVNode("div", { class: "food-price" }, [
                  /*#__PURE__*/_createElementVNode("h4", null, "$9.99")
                ])
              ])
            ]),
            /*#__PURE__*/_createElementVNode("div", { class: "food-card style-five" }, [
              /*#__PURE__*/_createElementVNode("div", { class: "food-img" }, [
                /*#__PURE__*/_createElementVNode("img", {
                  src: "https://images.pexels.com/photos/1640777/pexels-photo-1640777.jpeg?auto=compress&cs=tinysrgb&w=500&h=500&fit=crop",
                  alt: "Chicken Quesadilla"
                })
              ]),
              /*#__PURE__*/_createElementVNode("div", { class: "food-info-wrap" }, [
                /*#__PURE__*/_createElementVNode("div", { class: "food-title" }, [
                  /*#__PURE__*/_createElementVNode("h3", null, [
                    /*#__PURE__*/_createTextVNode(" Chicken Quesadilla "),
                    /*#__PURE__*/_createElementVNode("span", null, "(580 cal)")
                  ]),
                  /*#__PURE__*/_createElementVNode("p", null, " Grilled halal chicken with cheese, bell peppers, and onions in flour tortilla ")
                ]),
                /*#__PURE__*/_createElementVNode("div", { class: "food-price" }, [
                  /*#__PURE__*/_createElementVNode("h4", null, "$11.99")
                ])
              ])
            ])
          ])
        ]),
        /*#__PURE__*/_createElementVNode("div", {
          class: "tab-pane fade",
          id: "sides",
          role: "tabpanel"
        }, [
          /*#__PURE__*/_createElementVNode("div", { class: "food-list-wrap style-one" }, [
            /*#__PURE__*/_createElementVNode("div", { class: "food-card style-five" }, [
              /*#__PURE__*/_createElementVNode("div", { class: "food-img" }, [
                /*#__PURE__*/_createElementVNode("img", {
                  src: "https://images.pexels.com/photos/1059913/pexels-photo-1059913.jpeg?auto=compress&cs=tinysrgb&w=500&h=500&fit=crop",
                  alt: "Queso Blanco"
                })
              ]),
              /*#__PURE__*/_createElementVNode("div", { class: "food-info-wrap" }, [
                /*#__PURE__*/_createElementVNode("div", { class: "food-title" }, [
                  /*#__PURE__*/_createElementVNode("h3", null, [
                    /*#__PURE__*/_createTextVNode(" Queso Blanco "),
                    /*#__PURE__*/_createElementVNode("span", null, "(280 cal)")
                  ]),
                  /*#__PURE__*/_createElementVNode("p", null, " Creamy white cheese dip with roasted poblano peppers, served with tortilla chips ")
                ]),
                /*#__PURE__*/_createElementVNode("div", { class: "food-price" }, [
                  /*#__PURE__*/_createElementVNode("h4", null, "$7.99")
                ])
              ])
            ]),
            /*#__PURE__*/_createElementVNode("div", { class: "food-card style-five" }, [
              /*#__PURE__*/_createElementVNode("div", { class: "food-img" }, [
                /*#__PURE__*/_createElementVNode("img", {
                  src: _imports_0,
                  alt: "Guacamole"
                })
              ]),
              /*#__PURE__*/_createElementVNode("div", { class: "food-info-wrap" }, [
                /*#__PURE__*/_createElementVNode("div", { class: "food-title" }, [
                  /*#__PURE__*/_createElementVNode("h3", null, [
                    /*#__PURE__*/_createTextVNode(" Fresh Guacamole "),
                    /*#__PURE__*/_createElementVNode("span", null, "(240 cal)")
                  ]),
                  /*#__PURE__*/_createElementVNode("p", null, " Fresh avocados mashed with onions, cilantro, lime, and jalapeños ")
                ]),
                /*#__PURE__*/_createElementVNode("div", { class: "food-price" }, [
                  /*#__PURE__*/_createElementVNode("h4", null, "$6.99")
                ])
              ])
            ])
          ])
        ]),
        /*#__PURE__*/_createElementVNode("div", {
          class: "tab-pane fade",
          id: "desserts",
          role: "tabpanel"
        }, [
          /*#__PURE__*/_createElementVNode("div", { class: "food-list-wrap style-one" }, [
            /*#__PURE__*/_createElementVNode("div", { class: "food-card style-five" }, [
              /*#__PURE__*/_createElementVNode("div", { class: "food-img" }, [
                /*#__PURE__*/_createElementVNode("img", {
                  src: "https://images.pexels.com/photos/3026808/pexels-photo-3026808.jpeg?auto=compress&cs=tinysrgb&w=500&h=500&fit=crop",
                  alt: "Cinnamon Churros"
                })
              ]),
              /*#__PURE__*/_createElementVNode("div", { class: "food-info-wrap" }, [
                /*#__PURE__*/_createElementVNode("div", { class: "food-title" }, [
                  /*#__PURE__*/_createElementVNode("h3", null, [
                    /*#__PURE__*/_createTextVNode(" Cinnamon Churros "),
                    /*#__PURE__*/_createElementVNode("span", null, "(320 cal)")
                  ]),
                  /*#__PURE__*/_createElementVNode("p", null, " Crispy fried dough sticks coated in cinnamon sugar, served with chocolate dipping sauce ")
                ]),
                /*#__PURE__*/_createElementVNode("div", { class: "food-price" }, [
                  /*#__PURE__*/_createElementVNode("h4", null, "$5.99")
                ])
              ])
            ]),
            /*#__PURE__*/_createElementVNode("div", { class: "food-card style-five" }, [
              /*#__PURE__*/_createElementVNode("div", { class: "food-img" }, [
                /*#__PURE__*/_createElementVNode("img", {
                  src: "https://images.pexels.com/photos/291528/pexels-photo-291528.jpeg?auto=compress&cs=tinysrgb&w=500&h=500&fit=crop",
                  alt: "Tres Leches Cake"
                })
              ]),
              /*#__PURE__*/_createElementVNode("div", { class: "food-info-wrap" }, [
                /*#__PURE__*/_createElementVNode("div", { class: "food-title" }, [
                  /*#__PURE__*/_createElementVNode("h3", null, [
                    /*#__PURE__*/_createTextVNode(" Tres Leches Cake "),
                    /*#__PURE__*/_createElementVNode("span", null, "(380 cal)")
                  ]),
                  /*#__PURE__*/_createElementVNode("p", null, " Light sponge cake soaked in three kinds of milk, topped with whipped cream ")
                ]),
                /*#__PURE__*/_createElementVNode("div", { class: "food-price" }, [
                  /*#__PURE__*/_createElementVNode("h4", null, "$6.99")
                ])
              ])
            ])
          ])
        ]),
        /*#__PURE__*/_createElementVNode("div", {
          class: "tab-pane fade",
          id: "drinks",
          role: "tabpanel"
        }, [
          /*#__PURE__*/_createElementVNode("div", { class: "food-list-wrap style-one" }, [
            /*#__PURE__*/_createElementVNode("div", { class: "food-card style-five" }, [
              /*#__PURE__*/_createElementVNode("div", { class: "food-img" }, [
                /*#__PURE__*/_createElementVNode("img", {
                  src: "https://images.pexels.com/photos/1438072/pexels-photo-1438072.jpeg?auto=compress&cs=tinysrgb&w=500&h=500&fit=crop",
                  alt: "Horchata"
                })
              ]),
              /*#__PURE__*/_createElementVNode("div", { class: "food-info-wrap" }, [
                /*#__PURE__*/_createElementVNode("div", { class: "food-title" }, [
                  /*#__PURE__*/_createElementVNode("h3", null, [
                    /*#__PURE__*/_createTextVNode(" Horchata "),
                    /*#__PURE__*/_createElementVNode("span", null, "(180 cal)")
                  ]),
                  /*#__PURE__*/_createElementVNode("p", null, " Sweet rice milk drink with cinnamon and vanilla, served over ice ")
                ]),
                /*#__PURE__*/_createElementVNode("div", { class: "food-price" }, [
                  /*#__PURE__*/_createElementVNode("h4", null, "$3.99")
                ])
              ])
            ]),
            /*#__PURE__*/_createElementVNode("div", { class: "food-card style-five" }, [
              /*#__PURE__*/_createElementVNode("div", { class: "food-img" }, [
                /*#__PURE__*/_createElementVNode("img", {
                  src: "https://images.pexels.com/photos/1028716/pexels-photo-1028716.jpeg?auto=compress&cs=tinysrgb&w=500&h=500&fit=crop",
                  alt: "Agua Fresca"
                })
              ]),
              /*#__PURE__*/_createElementVNode("div", { class: "food-info-wrap" }, [
                /*#__PURE__*/_createElementVNode("div", { class: "food-title" }, [
                  /*#__PURE__*/_createElementVNode("h3", null, [
                    /*#__PURE__*/_createTextVNode(" Agua Fresca "),
                    /*#__PURE__*/_createElementVNode("span", null, "(120 cal)")
                  ]),
                  /*#__PURE__*/_createElementVNode("p", null, " Fresh fruit water in your choice of watermelon, lime, or hibiscus flavor ")
                ]),
                /*#__PURE__*/_createElementVNode("div", { class: "food-price" }, [
                  /*#__PURE__*/_createElementVNode("h4", null, "$2.99")
                ])
              ])
            ])
          ])
        ])
      ])
    ])
  ])
], -1))
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_3))
}